import React, {useState, useEffect, useRef} from "react";
import {Link} from "react-router-dom";
import {base, partners, partnersLegal, partnersIndividual, partnersPhysical} from "../../api";
import axios from "axios";
import {Toast} from "primereact/toast";
import {Button} from "primereact/button";
import {ConfirmDialog, confirmDialog} from "primereact/confirmdialog";
import {TabView, TabPanel} from "primereact/tabview";
import {Dialog} from "primereact/dialog";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {FilterMatchMode} from "primereact/api";
import {InputText} from "primereact/inputtext";
import PhisicalEditableForm from "./components/forms/PhisicalEditableForm";
import LegalEditableForm from "./components/forms/LegalEditableForm";
import {
	nameBody,
	detailsBody,
	bankDetailsBody,
	statusDetailsBody,
	companyNameBody,
	companyDetailsBody,
} from "./components/widgets/Widgets";
import PartnersDashboardStatisticCard from "./components/PartnersDashboardStatisticCard";

export default function PartnersDashboard() {
	const toast = useRef(null);
	const [visiblePhisical, setVisiblePhisical] = useState(false);
	const [visibleLegal, setVisibleLegal] = useState(false);
	const [userInfo, setUserInfo] = useState(null);
	const [loading, setLoading] = useState(true);
	const [visibleSelectedPhisicalPartner, setVisibleSelectedPhisicalPartner] = useState(false);
	const [selectedPhisicalPartner, setSelectedPhisicalPartner] = useState(null);
	const [visibleSelectedLegalPartner, setVisibleSelectedLegalPartner] = useState(false);
	const [selectedLegalPartner, setSelectedLegalPartner] = useState(null);
	const [dataPysical, setDataPysiscal] = useState([]);
	const [dataLegal, setDataLegal] = useState([]);
	const [dataIndividual, setDataIndividual] = useState([]);
	const [filters, setFilters] = useState({
		global: {value: null, matchMode: FilterMatchMode.CONTAINS},
	});
	console.log(dataPysical);

	function loadContent() {
		setLoading(false);
		axios
			.all([
				axios.get(base + partnersLegal),
				axios.get(base + partnersIndividual),
				axios.get(base + partnersPhysical),
			])
			.then(
				axios.spread((...response) => {
					setDataLegal(response[0].data);
					setDataIndividual(response[1].data);
					setDataPysiscal(response[2].data);
					setLoading(true);
				}),
			);
	}

	useEffect(() => {
		loadContent();
	}, []);

	function removeUser() {
		axios.delete(base + partners + localStorage.getItem("item")).then(() => loadContent());
	}

	const accept = () => {
		toast.current.show({
			severity: "success",
			summary: "Confirmed",
			detail: "You have accepted",
			life: 3000,
		});
		removeUser();
	};

	const reject = () => {
		toast.current.show({
			severity: "warn",
			summary: "Rejected",
			detail: "You have rejected",
			life: 3000,
		});
	};

	const confirmDelete = () => {
		confirmDialog({
			message: "Do you want to delete this record?",
			header: "Delete Confirmation",
			icon: "pi pi-info-circle",
			acceptClassName: "p-button-danger",
			accept,
			reject,
		});
	};

	const actionsPhisical = rowData => (
		<div className="d-flex justify-content-end">
			<Button
				icon="pi pi-pencil"
				severity="primary"
				className="mx-1"
				outlined
				rounded
				onClick={() => {
					setVisiblePhisical(true);
					setUserInfo(rowData);
				}}
			/>
			<Button
				icon="pi pi-trash"
				severity="danger"
				className="mx-1"
				outlined
				rounded
				onClick={() => {
					confirmDelete();
					localStorage.setItem("item", rowData.id);
				}}
			/>
		</div>
	);

	const actionsLegal = rowData => (
		<div className="d-flex justify-content-end">
			<Button
				icon="pi pi-pencil"
				severity="primary"
				className="mx-1"
				outlined
				rounded
				onClick={() => {
					setVisibleLegal(true);
					setUserInfo(rowData);
				}}
			/>
			<Button
				icon="pi pi-trash"
				severity="danger"
				className="mx-1"
				outlined
				rounded
				onClick={() => {
					confirmDelete();
					localStorage.setItem("item", rowData.id);
				}}
			/>
		</div>
	);

	const onGlobalFilterChange = event => {
		const value = event.target.value;
		let _filters = {...filters};
		_filters["global"].value = value;
		setFilters(_filters);
	};

	const onFilterHandler = e => {
		const globalValue = e.filters?.global?.value;
		if (globalValue && globalValue.length < 2) {
			let _filters = {...filters};
			_filters["global"].value = null;
			setFilters(_filters);
		} else {
			setFilters(e.filters);
		}
	};

	const renderHeader = () => {
		const value = filters["global"] ? filters["global"].value : "";
		return (
			<span className="p-input-icon-left w-100">
				<InputText
					type="search"
					value={value || ""}
					onChange={onGlobalFilterChange}
					placeholder="Global Search (min 2 characters)"
				/>
				<i className="pi pi-search position-absolute" style={{right: "20px"}} />
			</span>
		);
	};

	const header = renderHeader();

	return (
		<div className="col-12 mb-3 p-0">
			<div className="d-flex justify-content-end align-items-center mb-5 mt-3">
				<Link to="add_a_partner" className=" w-auto text-end border-0">
					<Button
						label="Ավելացնել նոր Գործընկեր"
						icon="pi pi-plus"
						rounded
						severity="primary"
						disabled
						className="me-3"
					/>
				</Link>
			</div>

			{loading ? (
				<TabView className="card b-radius b-shadow p-4">
					<TabPanel
						header="Ֆիզիկական անձ"
						rightIcon="pi pi-user ml-2"
						headerClassName="p-0"
						className="p-0">
						<DataTable
							value={dataPysical}
							selectionMode="single"
							selection={selectedPhisicalPartner}
							onSelectionChange={e => {
								setSelectedPhisicalPartner(e.value);
								setVisibleSelectedPhisicalPartner(true);
								setUserInfo(e.value);
							}}
							paginator
							rows={50}
							rowsPerPageOptions={[20, 30, 50, 100]}
							dataKey="id"
							filters={filters}
							onFilter={onFilterHandler}
							header={header}
							globalFilterFields={[
								"full_name_am",
								"full_name_en",
								"address_am",
								"address_en",
								"phone",
								"email",
							]}
							emptyMessage="No user found."
							bodyClassName="table table-hover">
							<Column header="Գործընկեր" body={nameBody} bodyClassName="small col-4" />
							<Column header="Տվյալներ" body={detailsBody} bodyClassName="small col-2" />
							<Column
								header="Բանկային տվյալներ"
								body={bankDetailsBody}
								bodyClassName="small col-2"
							/>
							<Column
								header="Ստատուս"
								body={statusDetailsBody}
								className="col"
								bodyClassName="small col-4"
							/>
							<Column
								header="Գործողություններ"
								className="col-1"
								body={actionsPhisical}
								bodyClassName="text-end"
							/>
						</DataTable>
					</TabPanel>
					<TabPanel
						header="Անհատ ձեռներեց"
						rightIcon="pi pi-user ml-2"
						headerClassName="p-0"
						className="p-0">
						<DataTable
							value={dataIndividual}
							selectionMode="single"
							selection={selectedLegalPartner}
							onSelectionChange={e => {
								setSelectedLegalPartner(e.value);
								setVisibleSelectedLegalPartner(true);
								setUserInfo(e.value);
							}}
							paginator
							rows={10}
							rowsPerPageOptions={[20, 30, 50, 100]}
							dataKey="id"
							filters={filters}
							onFilter={onFilterHandler}
							header={header}
							globalFilterFields={[
								"company_am",
								"company_en",
								"legal_full_name_am",
								"legal_full_name_en",
								"address_am",
								"address_en",
								"phone",
								"email",
							]}
							emptyMessage="No user found."
							bodyClassName="table table-hover">
							<Column
								header="Company details"
								sortable
								style={{width: "25%"}}
								body={companyNameBody}
								bodyClassName="small"
							/>
							<Column
								header="Details"
								sortable
								style={{width: "25%"}}
								body={companyDetailsBody}
								bodyClassName="small"
							/>
							<Column
								header="Bank"
								sortable
								style={{width: "25%"}}
								body={bankDetailsBody}
								bodyClassName="small"
							/>
							<Column header="Status" style={{width: "25%"}} bodyClassName="small" />
							<Column
								header="Actions"
								style={{width: "25%"}}
								body={actionsLegal}
								bodyClassName="text-center"
							/>
						</DataTable>
					</TabPanel>
					<TabPanel
						header="Կազմակերպություն"
						rightIcon="pi pi-user ml-2"
						headerClassName="p-0"
						className="p-0">
						<DataTable
							value={dataLegal}
							selectionMode="single"
							selection={selectedLegalPartner}
							onSelectionChange={e => {
								setSelectedLegalPartner(e.value);
								setVisibleSelectedLegalPartner(true);
								setUserInfo(e.value);
							}}
							paginator
							rows={10}
							rowsPerPageOptions={[20, 30, 50, 100]}
							dataKey="id"
							filters={filters}
							onFilter={onFilterHandler}
							header={header}
							globalFilterFields={[
								"company_am",
								"company_en",
								"legal_full_name_am",
								"legal_full_name_en",
								"address_am",
								"address_en",
								"phone",
								"email",
							]}
							emptyMessage="No user found."
							bodyClassName="table table-hover">
							<Column
								header="Company name"
								sortable
								style={{width: "25%"}}
								body={companyNameBody}
								bodyClassName="small"
							/>
							<Column
								header="Details"
								sortable
								style={{width: "25%"}}
								body={companyDetailsBody}
								bodyClassName="small"
							/>
							<Column
								header="Bank"
								sortable
								style={{width: "25%"}}
								body={bankDetailsBody}
								bodyClassName="small"
							/>
							<Column
								header="Status"
								style={{width: "25%"}}
								body={bankDetailsBody}
								bodyClassName="small"
							/>
							<Column
								header="Actions"
								style={{width: "25%"}}
								body={actionsLegal}
								bodyClassName="text-center"
							/>
						</DataTable>
					</TabPanel>
				</TabView>
			) : (
				<div className="col-12 d-flex justify-content-center align-items-center my-5 py-5">
					<span className="loader"></span>
				</div>
			)}
			<Toast ref={toast} />
			<ConfirmDialog />
			<Dialog
				className="col-lg-8 col-md-12"
				header={userInfo?.full_name_am || selectedPhisicalPartner?.full_name_am}
				visible={visibleSelectedPhisicalPartner}
				onHide={() => {
					setVisibleSelectedPhisicalPartner(false);
					setSelectedPhisicalPartner(false);
				}}>
				<PhisicalEditableForm
					data={selectedPhisicalPartner?.id || userInfo?.id}
					setVisible={setVisibleSelectedPhisicalPartner}
					loadContent={loadContent}
				/>
			</Dialog>
			<Dialog
				className="col-lg-8 col-md-12"
				header={userInfo?.company_am || selectedLegalPartner?.company_am}
				visible={visibleSelectedLegalPartner}
				onHide={() => {
					setVisibleSelectedLegalPartner(false);
					setSelectedLegalPartner(false);
				}}>
				<LegalEditableForm
					data={userInfo?.id || selectedLegalPartner?.id}
					setVisible={setVisibleSelectedLegalPartner}
					loadContent={loadContent}
				/>
			</Dialog>
			<Dialog
				header={userInfo?.full_name_am}
				visible={visiblePhisical}
				className="col-lg-8 col-md-12"
				onHide={() => {
					setVisiblePhisical(false);
				}}>
				<PhisicalEditableForm
					data={userInfo?.id}
					setVisible={setVisiblePhisical}
					loadContent={loadContent}
				/>
			</Dialog>
			<Dialog
				header={userInfo?.company_am}
				visible={visibleLegal}
				className="col-lg-8 col-md-12"
				onHide={() => {
					setVisibleLegal(false);
				}}>
				<LegalEditableForm
					data={userInfo?.id}
					setVisible={setVisibleLegal}
					loadContent={loadContent}
				/>
			</Dialog>
		</div>
	);
}
